import { CfgGlobalTemplateRealTimeData } from 'src/generated/signalR/cfg-global-template-real-time-data';

export class GlobalTemplateConfigurationsChanged {
   public static readonly type = '[GlobalTemplateConfigurationsChanged] Updated';

   constructor(public data: CfgGlobalTemplateRealTimeData) {}
}
